import React, { useState } from 'react'


const DateRangeSelector = () => {
    const [currentRange, setCurrentRange] = useState("All");



    return (
        <div className="rangeselect">
            <ul className='filterRange'>
                <li className={currentRange === "All" ? "currentRange active" : "currentRange"}
                    onClick={() => setCurrentRange("All")}>
                    All
                </li>
                <li className={currentRange === "W" ? "currentRange active" : "currentRange"}
                    onClick={() => setCurrentRange("W")}>
                    W
                </li>
                <li className={currentRange === "M" ? "currentRange active" : "currentRange"}
                    onClick={() => setCurrentRange("M")}>
                    M
                </li>
                <li className={currentRange === "6M" ? "currentRange active" : "currentRange"}
                    onClick={() => setCurrentRange("6M")}>
                    6M
                </li>
                <li className={currentRange === "Y" ? "currentRange active" : "currentRange"}
                    onClick={() => setCurrentRange("Y")}>
                    Y
                </li>
            </ul>
        </div>
    );
};

export default DateRangeSelector;